import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
function ScheduledOrderModifyIcon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <title>Scheduled Order Modify</title>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.4652 11.3863V12.4138H18.5743V11.3863H19.6018V12.4138H20.116C20.681 12.4138 21.1427 12.8755 21.1427 13.4413V20.6321C21.1427 21.198 20.681 21.6596 20.116 21.6596H12.9243C12.3535 21.6596 11.8968 21.198 11.8968 20.6321L11.9018 13.4413C11.9018 12.8755 12.3535 12.4138 12.9243 12.4138H13.4377V11.3863H14.4652ZM20.116 14.9821H12.9243V20.6321H20.116V14.9821ZM7.02665 2.34998V4.01664H13.6933V2.34998H15.36V4.01664H16.1933C17.1108 4.01664 17.86 4.76581 17.86 5.68331V11.1633H16.1933V8.18331H4.52665V17.35H10.6492L10.6483 19.0166H4.52665C3.60249 19.0166 2.85999 18.2666 2.85999 17.35L2.86832 5.68331C2.86832 4.76581 3.60249 4.01664 4.52665 4.01664H5.35999V2.34998H7.02665Z"
        />
      </g>
    </SvgIcon>
  );
}

export default ScheduledOrderModifyIcon;
